module.exports = __webpack_public_path__ + "src/images/react-logo.21cef5f5ff8f0a831ed1692e91e7154a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/react-logo.png
// module id = 106
// module chunks = 0